import { ThemeEvents, VariantUpdateEvent } from 'theme-events';

/**
 * A custom element that displays a product price.
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest(`.shopify-section`);
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest(`.shopify-section`);
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) return;

    const newPrice = event.detail.data.html.querySelector(`product-price [ref='priceContainer']`);
    const currentPrice = this.querySelector(`[ref='priceContainer']`);

    if (!newPrice || !currentPrice) return;

    // Only update if the price content has actually changed
    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
